const DEFAULTS = {
  config: {
    alignment: "center",
    size: "content"
  }
};
export {
  DEFAULTS
};
//# sourceMappingURL=defaults.js.map
